import { ArrowUpRight } from 'lucide-react';
import { describeAskDestination } from './askDestination';

export const AskActionCard = ({ action, data, testId, primary = false, children, onOpen }) => {
  const destination = describeAskDestination(action, data);
  const { Icon, title, hint, kind } = destination;
  return <button type="button" data-testid={testId} className={`ask-action-card${primary ? ' ask-primary-action' : ''}`}
    onClick={() => onOpen(action.url, destination)}>
    <Icon className="ask-action-icon" size={20} aria-hidden="true" />
    <span className="ask-action-content">
      <span className="ask-action-kind" data-testid={`${testId}-kind`}>{kind}</span>
      <strong data-testid={`${testId}-title`}>{title}</strong>
      <span className="ask-action-hint" data-testid={`${testId}-hint`}>{hint}</span>
      {children}
    </span>
    <ArrowUpRight className="ask-action-arrow" size={18} aria-hidden="true" />
  </button>;
};